
export default {
  cities: []
}
